var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { alias } from '@ember/object/computed';
import { fragment } from 'ember-data-model-fragments/attributes';
import CatalogObject, { CatalogObjectType } from '@square/dashboard-items-data/models/connect/catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
let VoidReason = (_dec = attr('string', {
  protoEnum: CatalogObjectTypeProto,
  defaultValue: CatalogObjectType.VOID_REASON
}), _dec2 = fragment('connect/void-reason/data'), _dec3 = alias('voidReasonData.name'), _dec4 = alias('voidReasonData.ordinal'), _dec5 = alias('voidReasonData.appointmentsType'), _class = (_class2 = class VoidReason extends CatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "voidReasonData", _descriptor2, this);
    _initializerDefineProperty(this, "name", _descriptor3, this);
    _initializerDefineProperty(this, "ordinal", _descriptor4, this);
    _initializerDefineProperty(this, "appointmentsType", _descriptor5, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/void-reason'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "voidReasonData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "name", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "appointmentsType", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { VoidReason as default };